/* eslint-disable */
import { BrowserRouter, Route, Routes } from "react-router-dom";

//Routes
import Home from "./views/pages/Home";
import { TranslationRoot } from "./views/pages/translation";

//styles
import "./styles/scss/styles.scss";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route exact path="*" element={<Home />} />
                <Route path="/translation/*" element={<TranslationRoot />} />
            </Routes>
        </BrowserRouter>
    );
}
